import React, { Component } from 'react';
import './styles.css';
import { titleHead } from './../../../services/helper'

class Page500 extends Component {
    componentDidMount() {
        titleHead('500')
    }

    render() {
        return (
            <div className="app flex-row align-items-center" style={{ "justifyContent": "center", textAlign: 'center', marginTop: '100px' }}>
                <span>
                    <h1 className="float-left display-3 mr-4" style={{ fontSize: '40px' }}>500</h1>
                    <h4 className="pt-3" style={{ fontSize: '17px' }}>We have a problem!</h4>
                    <p className="text-muted float-left">The page you are looking for is temporarily unavailable.</p>
                </span>
            </div>
        );
    }
}

export default Page500;


// WEBPACK FOOTER //
// ./src/containers/exception/500/index.js